import styled from 'styled-components'

export const HeadlineTitle = styled.h1`
  font-weight: 700;
  font-size: 18px;
  color: #1f166a;
`;
